import ConfirmForm from './ConfirmForm'

export {
  ConfirmForm
}



// WEBPACK FOOTER //
// ./src/views/ResetConfirm/components/index.js